<template>
  <button
    :class="
      compact
        ? [
            'flex px-3 py-2 items-center gap-2 row-container',
            `own-menu-row--${color}`,
          ]
        : ['own-menu-row', `own-menu-row--${color}`]
    "
    @click="$emit('click', $event)"
  >
    <component
      :is="actionItem.icon"
      v-if="actionItem.icon"
      :class="!compact && 'own-menu-row__icon'"
      :size="16"
      weight="bold"
    />
    <span class="text-title-regular" v-text="actionItem.label"></span>
  </button>
</template>

<script>
const ALLOWED_COLORS = ['danger']

export default {
  name: 'OwnMenuRow',
  props: {
    /**
     * Single action item
     */
    actionItem: { type: Object, required: true },

    /**
     * Display compact spacing of menu row
     */
    compact: { type: Boolean, default: false },
  },
  emits: ['click'],
  computed: {
    color() {
      const { actionItem } = this

      if (actionItem.color && ALLOWED_COLORS.includes(actionItem.color)) {
        return actionItem.color
      } else {
        return 'default'
      }
    },
  },
}
</script>

<style lang="scss">
@use '@/styles/globals';

.row-container {
  &:hover {
    background-color: var(--background-secondary);
  }
}

.own-menu-row {
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 2px;
  text-align: left;

  &__icon {
    font-size: 22px;
    margin-right: 8px;
  }

  &:hover {
    background-color: var(--background-secondary);
  }

  &--default {
    color: var(--text-color-secondary);
  }

  &--danger {
    color: var(--status-danger);
  }
}
</style>
